import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { logEvent } from '@refly/telemetry-web';
// styles
import './index.scss';
import { useSiderStoreShallow, useSubscriptionStoreShallow } from '@refly/stores';
import { PriceContent } from './priceContent';
import { useEffect } from 'react';
import marketIcon from '@refly-packages/ai-workspace-common/assets/market-icon.png';

export const SubscribeModal = () => {
  const { t } = useTranslation('ui');
  const {
    subscribeModalVisible: visible,
    setSubscribeModalVisible: setVisible,
    subscribeModalSource,
    openedFromSettings,
    setOpenedFromSettings,
  } = useSubscriptionStoreShallow((state) => ({
    subscribeModalVisible: state.subscribeModalVisible,
    setSubscribeModalVisible: state.setSubscribeModalVisible,
    subscribeModalSource: state.subscribeModalSource,
    openedFromSettings: state.openedFromSettings,
    setOpenedFromSettings: state.setOpenedFromSettings,
  }));

  const { setShowSettingModal } = useSiderStoreShallow((state) => ({
    setShowSettingModal: state.setShowSettingModal,
  }));

  useEffect(() => {
    if (visible) {
      logEvent('enter_pricing_page', 'settings');
    }
  }, [visible]);

  return (
    <Modal
      width={'100vw'}
      style={{
        height: 'var(--screen-height)',
        top: 0,
        paddingBottom: 0,
        maxWidth: '100vw',
      }}
      open={visible}
      footer={null}
      destroyOnHidden
      className="subscribe-modal !p-0"
      onCancel={() => {
        setVisible(false);
        // Only reopen SettingModal if SubscribeModal was opened from it
        if (openedFromSettings) {
          setShowSettingModal(true);
          setOpenedFromSettings(false); // Reset the flag
        }
        logEvent('subscription::price_table_close', 'settings');
      }}
    >
      <div className="w-full h-full overflow-auto flex flex-col items-center gap-3 py-8">
        <div className="text-[24px] m-auto flex items-center gap-2 text-[#1D2129] font-medium leading-8">
          {t('subscription.modalTitle')}
          <img src={marketIcon} alt="market-icon" className="w-[20px] h-[20px]" />
        </div>
        <div className="text-[16px] font-normal text-[#4E5969]">
          {t('subscription.pricingDescription')}
        </div>
        <PriceContent source="modal" entryPoint={subscribeModalSource || 'pricing_page'} />
      </div>
    </Modal>
  );
};
